import { Link } from 'react-router-dom';
import { NavTab, NavTabItem } from '@cimpress/react-components';
import type { Route } from '../routes';

interface SubHeaderNavTabProps {
    className?: string;
    routes: Route[];
    currentRoute: string;
}

export const SubHeaderNavTab = ({ className, routes, currentRoute }: SubHeaderNavTabProps) => {
    return (
        <NavTab className={className}>
            {routes.map(({ title, href, externalHref }) => (
                <NavTabItem key={href} active={href === currentRoute}>
                    {externalHref ? <a href={externalHref}>{title}</a> : <Link to={href}>{title}</Link>}
                </NavTabItem>
            ))}
        </NavTab>
    );
};
